import { Observable, type OperatorFunction, Subscriber } from "@suse-o11y/rxjs";

/**
 * Use to skip the emission of the next value when `skip` observable emits any value
 *
 * example:
 * source: | ---- 1 ----- 2 ----- 3 ----- 4 ----- 5 ----|
 * skip:   | ---------- x ----------- x ----------------|
 * result: | ---- 1 ------------- 3 ------------- 5 ----|
 *
 * @deprecated avoid using anything related to rxjs
 */
export const skipAfter =
	<T>(skip: Observable<unknown>): OperatorFunction<T, T> =>
	(source: Observable<T>) =>
		new Observable<T>((subscriber) => {
			const modifiedSubscriber = new Subscriber<T>(subscriber);
			let skipNext = false;

			modifiedSubscriber.add(
				skip.subscribe(() => {
					skipNext = true;
				}, subscriber.error),
			);

			modifiedSubscriber.next = (value) => {
				if (skipNext) {
					skipNext = false;
				} else {
					subscriber.next(value);
				}
			};

			return source.subscribe(modifiedSubscriber);
		});
